import { EHarvestSaleRoute } from '@/types'

export const getHarvestSaleLotsUrl = (id: string) => `${EHarvestSaleRoute.main}/${id}/lots`
export const getCulturePageUrl = (id: string) => `${EHarvestSaleRoute.main}/${id}`
